import { NoContentIcon, NoResultsIcon } from 'assets/icons';

export const NoAvailableMessageIcons = {
  NO_DATA: NoContentIcon,
  NO_RESULTS: NoResultsIcon,
};

export const NoAvailableMessageText = {
  NO_DATA: 'Sorry, but there is no data',
};
